/**
 * URL Validation Utilities
 *
 * Provides secure URL validation for redirect functionality
 */

import { ALLOWED_ORIGINS } from "./redirectConfig.js";

/**
 * Validate if a URL is safe to redirect to
 * @param {string} url - URL to validate
 * @returns {boolean} - True if URL is safe
 */
export const isValidReturnUrl = (url) => {
  if (!url || typeof url !== "string") {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    // Check if origin is in whitelist
    const isOriginAllowed = ALLOWED_ORIGINS.includes(parsedUrl.origin);

    // Additional security checks
    const isHttpOrHttps = ["http:", "https:"].includes(parsedUrl.protocol);
    // eslint-disable-next-line no-script-url
    const hasNoJavaScript = !url.toLowerCase().includes("javascript:");
    const hasNoDataUrl = !url.toLowerCase().startsWith("data:");

    return isOriginAllowed && isHttpOrHttps && hasNoJavaScript && hasNoDataUrl;
  } catch (error) {
    console.warn("Invalid URL format:", url, error);
    return false;
  }
};
